import { createTheme } from "@mui/material/styles";

export const DefaultSimplePayTheme = createTheme({
	palette: {
		primary: {
			main: "#0091b3",
			dark: "#027f9c",
			light: "#06b4dd",
		},
		secondary: {
			main: "#027f9c",   //buttons like submit button
			dark: "#027f9c",    //hover on button
		},
	},
});
